import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../../images/downWhite.svg";

const DownWhiteIcon = (props) => {
  return (
    <Wrapper onClick={props.onClick}>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default DownWhiteIcon;
